import React from "react";

export function userLabel(u) {
  if (!u) return "";
  const name = [u.first_name, u.last_name].filter(Boolean).join(" ").trim();
  return name || u.email || `User #${u.user_id ?? u.id ?? ""}`;
}

/**
 * Compact Assigned To dropdown — saves immediately on change.
 */
function AssignedToSelect({
  value,
  users = [],
  onChange,
  disabled = false,
  className = "assigned-to-select",
  ariaLabel = "Assigned to",
}) {
  const current = value != null && value !== "" ? String(value) : "";
  const hasCurrent = current && users.some((u) => String(u.user_id ?? u.id) === current);

  return (
    <select
      className={className}
      value={current}
      aria-label={ariaLabel}
      disabled={disabled || typeof onChange !== "function"}
      onChange={(e) => onChange?.(e.target.value)}
      onClick={(e) => e.stopPropagation()}
    >
      <option value="">— Unassigned —</option>
      {!hasCurrent && current ? (
        <option value={current}>User #{current}</option>
      ) : null}
      {users.map((u) => {
        const id = u.user_id ?? u.id;
        return (
          <option key={id} value={String(id)}>
            {userLabel(u)}
          </option>
        );
      })}
    </select>
  );
}

export default AssignedToSelect;
